<div [class.ghost]="isGhost" class="deviceName">
    <div class="ghost-remote-img">
        {{deviceName}}
    </div>
</div>
